import { FC, memo } from "react"
import { useHistory } from "react-router-dom"
import { useMediaQuery } from "../../hooks"

type Props = {
  title?: string
}

const OurCardsBlockComponent: FC<Props> = ({ title = "Our Cards" }) => {
  const history = useHistory()

  const isMobile = useMediaQuery("(max-width: 768px)")

  return (
    <div className="container" style={{ display: "flex", flexDirection: "column", padding: `0 ${isMobile ? "15px" : 0}`, gap: "40px" }}>
      {title && <h2 className="how__title title text-left">{title}</h2>}

      <div
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          gap: "20px",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            gap: "30px",
            padding: "40px",
            backgroundColor: "white",
            maxWidth: "100%",
          }}
        >
          <img
            src="./img/icons_new/card_blue.png"
            style={{ width: isMobile ? "auto" : "390px", height: isMobile ? "auto" : "247px" }}
            alt="card"
          />

          <div
            style={{
              display: "flex",
              gap: "20px",
              flex: 1,
              flexDirection: "column",
            }}
          >
            <span
              style={{
                fontSize: "42px",
                lineHeight: "115%",
                fontWeight: 900,
              }}
            >
              Physical
            </span>

            <span>
              Our cards are designed for all your transactions—swipe at stores or withdraw cash from ATMs with ease. Accepted everywhere,
              switch to our physical cards for a better payment experience.
            </span>
            <span>• 1-7 business day delivery</span>
            <span>• Online and in-store payments</span>
            <span>• ATM withdrawals</span>
            <span>• Contactless payments</span>
            <span>• Both chip and magnetic Stripe</span>
            <span>• Payments with Apple Pay and Google Pay</span>
          </div>

          <button
            onClick={() => history.push("/login")}
            style={{
              border: "none",
              outline: "none",
              height: "52px",
              borderRadius: "70px",
              alignSelf: "flex-start",
              padding: "0 20px 0 30px",
              backgroundColor: "#FC141C",
              display: "flex",
              gap: "10px",
              alignItems: "center",
              color: "#ffffff",
            }}
          >
            GET CARD
            <img src="./img/icons_new/chevron_icon.png" style={{ minWidth: "24px", maxWidth: "24px", height: "24px" }} alt=">" />
          </button>
        </div>

        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            gap: "30px",
            padding: "40px",
            backgroundColor: "white",
            maxWidth: "100%",
          }}
        >
          <img
            src="./img/icons_new/card_red.png"
            style={{ width: isMobile ? "auto" : "390px", height: isMobile ? "auto" : "247px" }}
            alt="card"
          />

          <div
            style={{
              display: "flex",
              gap: "20px",
              flex: 1,
              flexDirection: "column",
            }}
          >
            <span
              style={{
                fontSize: "42px",
                lineHeight: "115%",
                fontWeight: 900,
              }}
            >
              Virtual
            </span>

            <span>
              Say hello to easy digital shopping! Our virtual cards offer convenient, secure online transactions. Instantly generated and
              accessible from your smartphone or computer, they ensure peace of mind with advanced security features.
            </span>

            <span>• Online and in-store payments</span>
            <span>• ATM withdrawals</span>
            <span>• Contactless payments</span>
            <span>• Payments with Apple Pay and Google Pay</span>
          </div>

          <button
            onClick={() => history.push("/login")}
            style={{
              border: "none",
              outline: "none",
              height: "52px",
              borderRadius: "70px",
              alignSelf: "flex-start",
              padding: "0 20px 0 30px",
              backgroundColor: "#FC141C",
              display: "flex",
              gap: "10px",
              alignItems: "center",
              color: "#ffffff",
            }}
          >
            GET CARD
            <img src="./img/icons_new/chevron_icon.png" style={{ minWidth: "24px", maxWidth: "24px", height: "24px" }} alt=">" />
          </button>
        </div>
      </div>
    </div>
  )
}

export const OurCardsBlock = memo(OurCardsBlockComponent)
